import React, { Dispatch, SetStateAction } from 'react';
import Theme from '../../../styles/models/theme';
import {FlagContainer, Flag} from './styles';

interface CustomCountryFlagProps {
    theme: Theme;
}

const CustomCountryFlag: React.FC<CustomCountryFlagProps> = ({theme}) => {

  return <FlagContainer>
    <Flag type={'text'} value={'🇺🇸 +1'}  theme={theme} />
  </FlagContainer>
}

export default CustomCountryFlag;
